<template>
  <button
    class="filter-button"
    :style="{
      background: `${active ? color : ''}`,
    }"
  >
    <div
      class="circle"
      :style="{
        background: `${active ? background : color}`,
        'border-radius': `${circleSize}px`,
        width: `${circleSize}px`,
        height: `${circleSize}px`,
      }"
    ></div>
    <p
      class="text"
      :style="{
        color: `${active ? 'white' : 'black'}`,
      }"
    >
      {{ text }}
    </p>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    color: {
      default: 'black',
      type: String,
    },
    background: {
      default: '#eaeaf5',
      type: String,
    },
    circleSize: {
      default: 5,
      type: Number,
    },
    text: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="scss">
.filter-button {
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;
  user-select: none;
  background: #eaeaf5;
  border: none;
  .circle {
    margin-right: 4px;
  }
  .text {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;
  }
}

.calendar-sorting {
  .filter-button {
    margin-right: 10px;
    &:nth-last-of-type(1) {
      margin-right: 0px;
    }
  }
}

#app[data-theme='dark'] {
  .calendar-sorting {
    .filter-button {
      background: #d6d6d6;
    }
  }
}
</style>
